import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { WithdrawalTransactionOption } from '../../withdrawal-bank.config';

@Component({
  selector: 'app-withdrawal-inline-form',
  templateUrl: './withdrawal-inline-form.component.html',
})
export class WithdrawalInlineFormComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() transactionOptions: WithdrawalTransactionOption[] = [];
  @Input() applicationSelectorVariant: 'select' | 'text' = 'text';
  @Input() hasError = false;
  @Input() errorMessage = '';
  @Input() isSubmitting = false;
}
